export default "__VITE_ASSET__DQ7yDhRo__"